import { render, staticRenderFns } from "./PageCard.vue?vue&type=template&id=6badef80&scoped=true&"
import script from "./PageCard.vue?vue&type=script&lang=js&"
export * from "./PageCard.vue?vue&type=script&lang=js&"
import style0 from "./PageCard.vue?vue&type=style&index=0&id=6badef80&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6badef80",
  null
  
)

export default component.exports